import Script from "next/script";

export default function Form() {
  return (
    <>
      <div className="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
        <div
          id="cf-turnstile-widget"
          className="cf-turnstile checkbox"
          data-sitekey={process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY}
        />
      </div>

      <Script
        src="https://challenges.cloudflare.com/turnstile/v0/api.js"
        async={true}
        defer={true}
      />
    </>
  );
}
